import { render } from "./EventDetailPage.vue?vue&type=template&id=5b01a111&scoped=true"
import script from "./EventDetailPage.vue?vue&type=script&lang=js"
export * from "./EventDetailPage.vue?vue&type=script&lang=js"

import "./EventDetailPage.vue?vue&type=style&index=0&id=5b01a111&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b01a111"]])

export default __exports__